class Type {
	public static ONE_TIME = new Type(
		'ONE_TIME',
		'Do not re-enroll',
		'Campaign runs once. If this lead triggers the automation again, nothing happens.',
	);
	public static RESTART = new Type(
		'RESTART',
		'Re-enroll when triggered',
		'Restarts from step 1 once the campaign is complete. Triggers mid-campaign won\'t restart the campaign.',
	);
	public static RE_ENGAGE = new Type(
		'RE_ENGAGE',
		'Re-enroll after period of inactivity',
		'Restart only after a set number of days of no activity.',
	);

	private constructor(
		public readonly id: string,
		public readonly label: string,
		public readonly description: string,
	) {}

	public static values(): Type[] {
		return Object.values(Type).filter((v): v is Type => v instanceof Type);
	}

	public static getById(id: string): Type | undefined {
		return this.values().find((t) => t.id === id);
	}
}

export { Type as EnrollmentModeType };
